import { render, staticRenderFns } from "./PeriodPop.vue?vue&type=template&id=45441839&"
import script from "./PeriodPop.vue?vue&type=script&lang=js&"
export * from "./PeriodPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports